import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Company} from '../classes/company';
import {User} from '../classes/user.class';

@Injectable({
    providedIn: 'root'
})
export class FinancialService {

    constructor(private apiService: ApiService) {
    }

    public getHourlyCompanies() {
        return this.apiService.getCallData$<Company[]>('financial/hourlycompanies', null);
    }

    public getHourlyEmployees() {
        return this.apiService.getCallData$<User[]>('financial/hourlyemployees', null);
    }
}
